import { useDispatch } from "react-redux";

import { logout } from "shared/actions/authActions";
import { usePerformAfterInactivity } from "shared/hooks/useInteractionListener";

import LoginLayout from "ui/components/LoginLayout";
import MfaMethodSelectionForm from "ui/components/MfaMethodSelectionForm";

const MfaMethodSelectionPage = () => {
  const dispatch = useDispatch();

  usePerformAfterInactivity(() => {
    dispatch(logout());
  }, 2 * 60 * 1000); // logout after two minutes of inactivity

  return (
    <LoginLayout>
      <div className="MfaMethodSelectionPage">
        <MfaMethodSelectionForm required onCancel={() => dispatch(logout())} />
      </div>
    </LoginLayout>
  );
};

export default MfaMethodSelectionPage;
